import { environment } from 'src/environments/environment';

const ROOT_URL = environment.api.hub;
const ID_URL = environment.api.id;

export const API_URLS = {
  root: ROOT_URL,

  //hub
  HUB_USER: `${ROOT_URL}/hubUser`,
  UPDATE_HUB_USER: `${ROOT_URL}/hubUser/hubUserSettings`,
  COUNTRIES_LIST: `${ROOT_URL}/accounts/registrationOptions/getCountries`,

  //account
  ACCOUNTS_SEARCH: `${ROOT_URL}/accounts/searchBy`,
  LOAD_ACCOUNT: `${ROOT_URL}/accounts/details`,
  LOAD_SUBSCRIPTIONS: `${ROOT_URL}/accounts/subscriptions`,
  ADD_SUBSCRIPTIONS: `${ROOT_URL}/accounts/createSubscription`,
  EDIT_SUBSCRIPTION: `${ROOT_URL}/accounts/updateSubscription`,
  ADD_SITELICENCE: `${ROOT_URL}/accounts/siteLicense`,
  ADD_FREE_TRIAL: `${ROOT_URL}/accounts/freeTrial`,
  ADD_LITERACY_OFFER: `${ROOT_URL}/accounts/literacyOffer`,
  LOAD_ACCOUNT_NOTES: `${ROOT_URL}/accounts/accountHistory`,
  SUBMIT_ACCOUNT_NOTE: `${ROOT_URL}/accounts/addAccountNote`,
  UPDATE_ACCOUNT_NOTE: `${ROOT_URL}/accounts/updateAccountNote`,
  EXPORT_ACCOUNT: `${ROOT_URL}/export/report`,
  UPDATE_ACCOUNT_DETAILS: `${ROOT_URL}/accounts/details/update`,
  RESEND_WELCOME_EMAIL: `${ROOT_URL}/email/newAccountWelcomeEmail`,
  RESEND_HUBSPOT_INTEGRATION_MESSAGE: `${ROOT_URL}//hubspot/integration/resendFreetrialMessage`,
  CHANGE_ACCOUNT_LANGUAGE: `${ROOT_URL}/accounts/changeLanguage`,
  CHANGE_ACCOUNT_STATUS: `${ROOT_URL}/accounts/setStatus`,
  DELETE_ACCOUNT: `${ROOT_URL}/accounts/delete`,
  RESET_ACCOUNT_PASSWORD: `${ROOT_URL}/email/passwordResetEmail`,
  UPDATE_EXTERNAL_SCHOOL_IDENTIFIER: `${ROOT_URL}/accounts/details/update/schoolSource`,

  // new account
  CREATE_NEW_ACCOUNT: `${ROOT_URL}/accounts/create`,
  BULK_ACCOUNT_IMPORT: `${ROOT_URL}/bulkAccountCreation/bulkCreate`,
  PREVIOUS_BULK_IMPORTS: `${ROOT_URL}/bulkAccountCreation/events`,

  // teachers
  LOAD_ACCOUNT_TEACHERS: `${ROOT_URL}/accounts/users/search`,
  ADD_ACCOUNT_TEACHER: `${ROOT_URL}/teacher/upsert`,
  DELETE_ACCOUNT_TEACHER: `${ROOT_URL}/teacher/delete`,
  RESEND_TEACHER_WELCOME_EMAIL: `${ROOT_URL}/email/resendUserWelcomeEmail`,
  CHECK_EMAIL_AVAILABILITY: `${ID_URL}accountuser/exists`,

  //students
  LOAD_ACCOUNT_STUDENTS: `${ROOT_URL}/accounts/students`,
  SYNC_STUDENT_LICENSES: `${ROOT_URL}/students/refreshClaims`,
  SYNC_ALL_ACCOUNTS_STUDENT_LICENSES: `${ROOT_URL}/students/refreshClaimsForAccount`,
  LOAD_STUDENT_GROUPS: `${ROOT_URL}/accounts/groups`,

  // support
  CLEVER_ACCOUNT_SEARCH: `${ROOT_URL}/sso/clever/getAccount`,
  CLEVER_ACCOUNT_UPDATE: `${ROOT_URL}/sso/clever/upsertDistrict`,
  UNDELETE_ACCOUNT_SEARCH: `${ROOT_URL}/students/deleted`,
  UNDELETE_STUDENT_RESTORE: `${ROOT_URL}/students/undelete`,

  //account usage
  LOAD_ACCOUNT_USAGE: `${ROOT_URL}/reporting/usageStatsReportData`,

  //reports
  FREE_TRIAL_REPORT: `${ROOT_URL}/reporting/freeTrialReport`,
};
